// extracted by mini-css-extract-plugin
export default {"navigation":"styles_navigation__Jh88B","button":"styles_button__71t9Q","buttonNext":"styles_buttonNext__vT9kC","buttonConfirm":"styles_buttonConfirm__F3YD1"};